import React from "react";
export default ({ children }) => {
  return <div className="page">{children}</div>;
};



// WEBPACK FOOTER //
// ./src/components/common/Page.js